export default __webpack_public_path__ + "static/media/step-4.9aa35d3b.png";